<!--创建表弹窗-->
<template>
	<dialogBody ref="dialogBody" @confirm="confirm" @cancel="cancel">
		<p slot="title">{{deviceBean.deviceName?deviceBean.deviceName:deviceBean.name}}</p>
		<div class="flexStart">
			<p>每月扣款日：</p>
			<input type="number" min="1" max='30' v-model="deductionFeeDay">
		</div>
		<div class="flexStart">
			<p>计费方式 : </p>
			<span class="span-m">
				<span :key="index" v-for="(i,index) in billType" @click="billingMode = i.en">
					<img :src="getImg(i.en)" />{{i.zh}}
				</span>
			</span>
		</div>
		<div class="flexStart" v-if="billingMode == 'SingleBilling'">
			<p>单价(元/kW·h) ：</p>
			<input type="number" min="0" v-model="singlePrice">
		</div>
		<div v-else-if="billingMode == 'StepBilling'" class="stepDiv">
			<div class="flexStart">
				<p>第一档：0 - </p>
				<input type="number" min="0" v-model="step1">
				<p>(kW·h)</p>
				<input type="number" min="0" v-model="stepPrice1">
				<p>(元/kW·h)</p>
			</div>
			<div class="flexStart">
				<p>第二档：{{step1}} - </p>
				<input type="number" min="0" v-model="step2">
				<p>(kW·h)</p>
				<input type="number" min="0" v-model="stepPrice2">
				<p>(元/kW·h)</p>
			</div>
			<div class="flexStart">
				<p>第三档({{step2}}以上):</p>
				<input type="number" min="0" v-model="stepPrice3">
				<p>(元/kW·h)</p>
			</div>
		</div>
	</dialogBody>
</template>

<script>
	import resourcesStore from '@/cache/resourcesStore.js'
	import dialogBody from '@/components/module/dialog/dialogBody.vue'
	export default {
		components: {
			dialogBody
		},
		props: [],
		data() {
			return {
				deviceBean: {},
				isEdit: false,
				billType: [{
						zh: '单价计费',
						en: 'SingleBilling'
					},
					{
						zh: '阶梯计费',
						en: 'StepBilling'
					},
					// {
					// 	zh: '峰平谷计费',
					// 	en: 'PeakAndValleyBilling'
					// },
				],
				billingMode: 'SingleBilling',
				singlePrice: 1.00,
				deductionFeeDay: 1,
				step1: 200,
				stepPrice1: 0.62,
				step2: 400,
				stepPrice2: 0.67,
				stepPrice3: 0.92,
			}
		},
		created() {},
		mounted() {},
		destroyed() {},
		computed: {
			getImg() {
				return i => {
					if (i == this.billingMode) {
						return resourcesStore.getters.getResourcesByName("checkBox/checked.png")
					}
					return resourcesStore.getters.getResourcesByName("checkBox/unchecked.png")
				}
			}
		},
		watch: {
			deductionFeeDay(nv, ov) {
				if (isempty(nv) || parseInt(nv) != this.deductionFeeDay) {
					if (isempty(ov)) {
						this.deductionFeeDay = 1
					} else {
						this.deductionFeeDay = ov
					}
				}
				if (nv <= 0 || nv > 30) {
					this.deductionFeeDay = ov
				}
			}
		},
		methods: {
			show(deviceBean, isEdit) {
				this.deviceBean = deviceBean
				this.isEdit = isEdit
				if (isEdit) {
					//是编辑
					this.billingMode = deviceBean.billingMode
					this.deductionFeeDay = deviceBean.deductionFeeDay
					switch (deviceBean.billingMode) {
						case 'SingleBilling':
							this.singlePrice = deviceBean.deductionStandard
							break
						case 'StepBilling':
							var s = deviceBean.deductionStandard.split(';')
							var s1 = s[0].split(':')
							var s2 = s[1].split(':')
							var s3 = s[2].split(':')
							this.step1 = s1[0]
							this.stepPrice1 = s1[1]
							this.step2 = s2[0]
							this.stepPrice2 = s2[1]
							this.stepPrice3 = s3[0]
							break
					}
				}
				this.$refs.dialogBody.open()
			},
			confirm() {
				//计算信息
				var deductionStandard = ''
				switch (this.billingMode) {
					case 'SingleBilling':
						deductionStandard = this.singlePrice
						break
					case 'StepBilling':

						deductionStandard = this.step1 + ":" + this.stepPrice1 + ";" + this.step2 + ":" + this.stepPrice2 + ";" + this.stepPrice3
						break
				}
				this.$api.meterReadingApi.saveMeterReadingConfig(this.deviceBean.id, this.billingMode, this.deductionFeeDay,
					deductionStandard, respon => {
						respon.deviceName = getValueIfNoNull(this.deviceBean.deviceName, this.deviceBean.name)
						this.$emit('createSuccess', respon)
						this.cancel()
						this.$dialogMethod.showMessage('提交成功！')
					})
			},
			cancel() {
				this.$refs.dialogBody.hide()
			}
		}
	}
</script>

<style scoped>
	.span-m {
		border: solid #d4d4d4 .01rem;
		border-radius: .05rem;
		line-height: 0.28rem;
		margin: 0 5px;
		height: 0.28rem;
		padding: 0 5px;
		display: flex;
		align-items: center;
		color: white;
	}

	.span-m span {
		text-align: center;
		display: flex;
		align-items: center;
		margin-right: 0.05rem;
		cursor: pointer;
	}

	.span-m img {
		width: .13rem;
		height: .13rem;
		margin-right: .05rem;
	}

	.flexStart {
		margin-top: 10px;
	}

	.stepDiv input {
		width: 50px;
		margin: 0 10px;
	}
</style>
